<template>
  <div class="project-item">
    <ProjectItem :project="project" />
    <div class="paginations">
      <div class="link-back">
        <NuxtLink  v-show="projectPrevShow" :to="`/project/${projectPrev}`">предыдущая работа</NuxtLink>
      </div>
      <div  class="link-next">
        <NuxtLink v-show="projectNextShow" :to="`/project/${projectNext}`">следующая работа</NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {ref, onMounted, computed} from 'vue';
const route = useRoute();
const projectId = Number(route.params.id);

console.log('projectId', projectId)

const project = computed(() => projectList.find(el => el.id === projectId));

// Примерный список проектов, возможно, лучше вынести в отдельный файл или API
const projectList = [
  {
    id: 0,
    name: "Ggwin",
    desc: "responsive, rem, gulp, PUG, SASS",
    img: "/img/port/ggwin.webp",
    link: "https://p-store.ru/ruletka2/inventar-slider.html",
    github: ""
  },
  {
    id: 1,
    name: "LilySammer",
    desc: "vue.js, vuex, webpack, PUG, SASS",
    img: "/img/port/lily.webp",
    link: "",
    github: "https://github.com/ItJustAlance/lily-kviz"
  },
  {
    id: 2,
    name: "World Wentures",
    desc: "animations",
    img: "/img/port/trans.webp",
    link: "https://p-store.ru/transplanetary/templates/sectors.html",
    github: ""
  },
  {
    id: 3,
    name: "mi-74.ru",
    desc: "design, adaptive, front-end, back-end, seo optimize, sheme.org(article, shop, contacts), the site is optimized and gives out 97 points in 'google page speed'",
    img: "/img/port/mi-74.webp",
    link: "https://mi-74.ru",
    github: ""
  },
  {
    id: 4,
    name: "lgcity.ru",
    desc: "adaptive, gulp, PUG, SASS, skeleton.js",
    img: "/img/port/lgcity.webp",
    link: "https://lgcity.ru",
    github: ""
  },
  {
    id: 5,
    name: "ford-service",
    desc: "Адаптивная верстка с калькулятором расчета стоимости ТО и взаимосвязь с бэком",
    img: "/img/port/ford.webp",
    link: "https://p-store.ru/anna-ford/"
  }
];


// Проверяем, есть ли предыдущий или следующий проект
const projectPrevShow = computed(() => projectId > 0);
const projectNextShow = computed(() => projectId < projectList.length - 1);

const projectPrev = computed(() => projectPrevShow.value ? projectId - 1 : null);
const projectNext = computed(() => projectNextShow.value ? projectId + 1 : null);


</script>

<style lang="sass">

</style>
